import { Box } from 'components/Box';

/**
 * @deprecated Use `styled.div` instead
 */
export const Container = Box;
